export default __webpack_public_path__ + "static/media/ArrowRight.63711757.svg";